// ==============API READ TUTORIAL ================
export const TUTORIAL_READ_SUCCESS = 'tutorial read request success'
export const TUTORIAL_SET_TO_DONE = 'tutorial set to done';
export const TUTORIAL_SET_CURRENT_ITEM = 'tutorial set current item';
export const TUTORIAL_SET_CURRENT_LIST = 'tutorial set current list'
export function tutorialReadSuccess(isFetching) {
    return {
        type: TUTORIAL_READ_SUCCESS,
        isFetching: isFetching,
    }
}

export function tutorialSetToDone(listId, itemId){
    return{
        type: TUTORIAL_SET_TO_DONE,
        listId: listId,
        itemId: itemId   
    }
}

export function tutorialSetCurrentItem(id){
    return{
        type: TUTORIAL_SET_CURRENT_ITEM,
        id: id
    }
}

export function tutorialSetCurrentList(id){
    return{
        type: TUTORIAL_SET_CURRENT_LIST,
        id: id
    }
}


// WEBPACK FOOTER //
// ./src/model/Tutorial/actions.js